import api from '../../../App/socket';

export const setLeadValuation = (_id, valuation, description, suggested_margin, retail_price, reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_reason, is_trade) => (

    api.send({
        api: 'db',
        model: 'Lead',
        action: 'NestedCreate',
        options: {
            fullPath: 'valuations',
            where: { _id },
            create: {
                valuation, description, suggested_margin, retail_price, reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_reason, is_trade, valuation_type: 'Agent',
            },
        },
    }).then((response) => response).catch((error) => error)

);

export const setLatestLeadMargin = (_id, suggested_margin) => (

    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: {
                _id,
            },
            update: {
                last_valuation_date: new Date(),
                latest_margin: suggested_margin,
            },
        },
    }).then((response) => response).catch((error) => error)

);

export const updateCustomerCollectionDate = (_id, customer_collection_date) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: {
                _id,
            },
            update: {
                customer_collection_date,
            },
        },
    }).then((response) => response).catch((error) => error)

);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/set_lead_valuation_request.js